// AUTO-GENERATED by scripts/gen-custom-exports.mjs - Do not edit manually
//
// This file provides a single import path for custom components,
// eliminating preload warnings from try/catch dynamic imports.

// form-embed-form-handler
export { FormEmbedFormHandler } from './form-embed-form-handler'; // custom

// form-embed-additional-content
export { FormEmbedAdditionalContent } from './form-embed-additional-content'; // custom

// footer-default-additional-content
export { FooterAdditionalContentTop } from './footer-default-additional-content'; // custom
export { FooterAdditionalContentBottom } from './footer-default-additional-content'; // custom

// hero-advanced-additional-content
export { HeroAdvancedAdditionalContent } from './hero-advanced-additional-content'; // custom

// link-resolvers
export { customLinkResolvers } from './link-resolvers'; // custom

// consent-manager
export { consentManagerAdapter } from './consent-manager'; // custom

// html-block-form-handler
export { HtmlBlockFormHandler } from '@/app/_components/empty-fallback'; // fallback
